"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWizardStepContext = exports.WizardStepContextProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var StepContext = (0, react_1.createContext)(null);
var WizardStepContextProvider = function (_a) {
    var stepId = _a.stepId, step = _a.step, children = _a.children;
    var context = (0, react_1.useMemo)(function () { return ({ stepId: stepId, step: step }); }, [stepId, step]);
    return ((0, jsx_runtime_1.jsx)(StepContext.Provider, __assign({ value: context }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) })));
};
exports.WizardStepContextProvider = WizardStepContextProvider;
var useWizardStepContext = function () {
    var context = (0, react_1.useContext)(StepContext);
    if (!context) {
        throw new Error('No context found, please ensure you are using this hook from inside a Wizard Page');
    }
    return context;
};
exports.useWizardStepContext = useWizardStepContext;
//# sourceMappingURL=WizardStepContext.js.map